<template>
	<div>
		<w-card
			:tile="true"
			shadow
			class="xs12 md12 lg12 xl12 primary mt1 pa0 titleCard"
			v-for="nasaha in nasahaList"
			:key="nasaha.id"
		>
			<p>
				<w-icon class="mr1">wi-check</w-icon>
				{{ nasaha.title }}
			</p>
			<div
				class="setting info-dark2--bg white edit"
				@click="editNasaha(nasaha)"
			>
				<i class="mdi mdi-pencil"></i>
			</div>
			<div
				class="setting error--bg white delete"
				@click="deleteConfirm(nasaha)"
			>
				<i class="mdi mdi-delete"></i>
			</div>
		</w-card>
		<site-loader
			:noresult="progress == 0"
			:loading="progress == 1"
		></site-loader>
		<confirm
			:show="showConfirm"
			:btnLoad="isDeleting"
			@on-confirm="deleteNasaha"
		/>
	</div>
</template>
<script>
import axios from 'axios';
import confirm from '../confirm.vue';
export default {
	components: { confirm },
	props: ['isChanged'],
	emits: ['edit-nasaha'],
	data() {
		return {
			nasahaList: [],
			progress: null,
			showConfirm: false,
			toDelete: null,
			isDeleting: false,
		};
	},
	methods: {
		async getNasaha() {
			this.progress = 1;
			try {
                var form = new FormData();
                form.append('status','all');
				const response = await axios.post('nasaha.php', form);
				let res = response.data.status;
				this.nasahaList = res == 200 ? response.data.data : [];
				// alert(JSON.stringify(response))
				this.progress = null;
			} catch (error) {
				this.progress = null;
				console.log(error);
			}
		},
		editNasaha(nasaha) {
			this.$emit('edit-nasaha', nasaha);
		},
		deleteConfirm(nasaha) {
			this.showConfirm = true;
			this.toDelete = nasaha;
		},
		deleteNasaha(result) {
			if (result) {
				this.isDeleting = true;
				var formData = new FormData();
				formData.append('status', -1);
				formData.append('nasahaId', this.toDelete.id);
				formData.append('title', '');
				formData.append('detail', '');
				axios
					.post(
						'nasaha.php',
						formData
					)
					.then((data) => {
						this.showConfirm = false;
						this.isDeleting = false;
						let result = data.data;
						if (result.status == 200) {
							this.getNasaha();
						} else {
							alert('Fail To Delete');
						}
					})
					.catch((error) => {
						this.showConfirm = false;
						this.isDeleting = false;
						alert('Fail To Delete\n ' + error);
					});
			} else {
				if (!this.isDeleting) {
					this.showConfirm = false;
				}
			}
		},
	},
	watch: {
		isChanged() {
			this.nasahaList = [];
			this.getNasaha();
		},
	},
	mounted() {
		this.getNasaha();
	},
};
</script>
<style scoped></style>
